var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0_5180_6155)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5180_6155",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5180_6155",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5180_6155",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE4ElEQVR4nM1aW4scRRSuzRI14iVr2Ok67W7WbCIB39RFX9RgVAiamw9VpzNRJCRswD+RnxAigi8+KFEjCaKyXnAlqyAkq/iaXxFJvEa3q9iS0zM7U9XdM9Pd09WTAwXLdvWp8/W5nxrGPJGJWoHB2b2xgKdp0d/mjaDF7mYyYuZhJeG4kvyCRvhZIfyuEUzeUshvJ3skv0DvmJOPPDRp+ZmK4BWF/JKS/N9Bgo9aCvkdhfwTJcOXJwAgPKoRfi0g5IaS/JZC2CwI7BeFwWHvAMjOtYRvc4WW8LdG/rmW/Gws+AGD4bw5x7Y577d3z8QRX9ISziiEiwQyF5CEr0y7tegFhEb+pkL4K+fgH5UMj5i3Fu4ry5Pe0RJOaglX01pTCH/Ss9oAGMGmFcJ7OQDWYgHP1XXOhoSnNPJrOZp+l2QYD8ShffdqCZ9lmfP3DWNTdYHoncfYlJbhKSX5zZSpXSFZqjEVbDoXBMKm73xgRLBHIdxInX057XOFaIA5kar/YA3lJi35d6ko+E5pxx4WJs2JRx9nDZBZZtu15KvO+QJOFHsZZ/cOiE6WzfJVI564xzsSxpg5trDTNjOKZmR6I19M5wnyidySQ/IvGgMjyGf4b5bzrxTJ2G506jo2mVNGzQ2C0QinU7K9OmyzXXaspUMsCU3CTwKMOce2aQnrllbWBxaAtoAxwvO5DCcIJo74kl0BqCg4mAUi+acW2h9GRhOqq1y/+bpy0ipBWsI3Vjj+KNtPIL/Tt7/wyCiGk9KMioLXLCD/mKO7HrQewut2FVu0AJyEZswy225HMOejU8a0v2opxhPQjJL8Y0sr53sPqPW0hDhblnHTYDTCsnXW9d6Dbh/diVaCH6jCvEkzi6PgWUsjtzsCCD7r1FEYzlc9oCnNmPbuGUfm4+GuTsbuo/uvUqncMBhDLYYNRMzt63Zm9ZboTZiZQtBbvDei8EkXCPKNug7yDUYlww4LiG1aHTWN2R83YGaG5ggSYse0Ms5+bGFnXUB8gTEYPJZx9kz4jfhSnUB8mJmKgoNWOX9rQEKEM8wD1akZLfnb+QmxM3ze6ggvMk9UFxgtYSW3RKGpuJ0pjZjbwTzRuGZmxNwOqnr78lqzYhrt22W8Rmj7AjKuZlS6UhezD7gbkF+y/OQq80xVNaOR/zTUDeh+wtqwSYmSeaaymoklf8Heq2TwYi5jup/ob+TXfMx3q4IxNBdGWMuNVmkix3EZhqd8AxkIBvn3RoT7k+fRfKgQPnS0EfFDQ5nSJYuVbG4Wmup5AwNJIZv+n5b8y9EM261Fe2RK40oaTjQIZjUjeAoYlSiFGCa3SO4XWKUo0wyYcP8wIBpDLMWQbooyYGouKIuU6NrWhp3FS170XHEZwQ1vl5Rb50aJY2dugWmAWLl7Ta7eEC6nvgrNlE6P2xLnnsfYlEL4IBfEuK0yCezMvfrZf73Okr+b7NbyzKnWj0b1V3Jl7JraJs1iaYxZJRiYw3B/p3bqlx3aCbslHbvwwSLYY5fQaZPrTgCXYxE8QyMb9102TWEzaYqon5CwkipUnTxROMSOQ3TJ4txVjFjUGtg99pB1fWTG9gIIw5dotG/3B2UXhdqER95dR9NEPQFNxckxk6866Dcm3R472YP8PNV2mX6C3WVEkw3KOb0fnrVbi71phwf6H5lA4fNsGfXiAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/Blocked.e35a0fbd50f5883bf0566d846b44fe9d.svg";
export { ForwardRef as ReactComponent };